import { IRootState } from '../../../store'

export const getLoaderSelector = (state: IRootState) => state.loader
